<!-- css -->
<style type="text/css" scoped>
.main {
  display: flex;
  flex-direction: column;
}

.main-header {
  height: 128px;
}

</style>
<!-- html -->
<template>
  <div class="main">
    <!-- header -->
    <n-header class="main-header" ref="header" @search="handelSearch" @change="searchChange" @clear="searchClear" @topup="topup" v-show="showHeader"></n-header>
    <!-- router -->
    <router-view></router-view>
  </div>
</template>
<!-- javascript -->
<script type="text/javascript">
import Tool from '../../common/tool'
import Head from './NIMianHead.vue'
import Storage from '../../common/storage'
import Fetch from '../../common/fetch'
import * as main from './NIMain.js'
import wechat from '../../common/wechat'
import {
  Toast
} from 'mint-ui'

export default {
  name: 'main',
  components: {
    'n-header': Head
  },
  data: function(argument) {
    return {
      showHeader: false,
      userInfo: {
        coin: '',
        name: '',
        portrait: ''
      },
      localizated: false,
      isSearched: false,
      wechatInited: false
    }
  },
  mounted: function(argument) {
    if (Storage.queryItem('userInfo') !== null) {
      // 初始化微信Sdk
      wechat.initConfig(this)
      this.wechatInited = true
    }

    this.updateUI()
    this.loadUserLoginReq()
  },
  methods: {
    updateUI: function(argument) {
      document.getElementsByClassName('main')[0].style.height = document.body.clientHeight + 'px' // header 展示逻辑
      if (parseInt(Tool.query('type')) === 3 || parseInt(Tool.query('autopay')) === 1) {
        this.showHeader = false
      } else {
        this.showHeader = true
      }
    }, // 本地化数据
    localizationUserInfo: function(userInfo) {
      var userInfoJson = JSON.stringify(userInfo)
      Storage.setItem('userInfo', userInfoJson)
      Storage.setItem('coin', userInfo.coin)
      if (this.wechatInited === false) {
        // 初始化微信Sdk
        wechat.initConfig(this)
        this.wechatInited = true
      }
    }, // 用户登录
    loadUserLoginReq: function(argument) {
      let _this = this
      let code = Tool.query('code')
      if (code === null) {
        Toast({
          message: '请检查参数',
          position: 'middle',
          duration: 1000
        })
        return
      }

      var options = {
        code: code,
        state: 'gzh'
      }

      if (Tool.query('sharer') != null) {
        options.sharer = Tool.query('sharer')
      }

      Fetch.loadUserLogin(options).then(resp => {
        console.log(resp)
        if (resp.code === 0) {
          Storage.setItem('logan', 'yes')
          _this.localizationUserInfo(resp.data)
          _this.userInfo = {
            coin: resp.data.coin,
            name: resp.data.name,
            portrait: resp.data.portrait
          }
          _this.$refs.header.updateUserInfo(this.userInfo)
          _this.switchRoute()
        }
      }).catch(error => {
        console.log(error)
      })
    }, // 充值点击
    topup: function(argument) {
      this.$router.push('topup')
    }, // 清除搜索回调
    searchClear: function(argument) {
      if (this.isSearched === true) {
        this.isSearched = false
        var type = parseInt(Tool.query('type'))
        // 重新加载小区
        if (type === 0) {
          this.$store.commit('reloadCommunities')
          return
        }
        // 重新加载商圈
        if (type === 1) {
          this.$store.commit('reloadBusiness')
          return
        }
        // 重新加载县区
        if (type === 2) {
          this.$store.commit('reloadCounties')
          return
        }
      }
    },
    // 时时搜索
    searchChange: function(val) {
      if (!val || val.length === 0) {
        this.searchClear()
      }
    }, // 点击搜索按钮
    handelSearch: function(val) {
      let vm = this
      if (Storage.queryItem('coin') === null || parseInt(Storage.queryItem('coin')) <= 0) {
        Toast({
          message: '余额不足请充值',
          duration: 1000
        })
        let timer = setTimeout(function(argument) {
          vm.$router.push('/topup')
          clearTimeout(timer)
        }, 1000)
        return
      }
      var _this = this
      main.search(val, function(data, status, type) {
        console.log(status)
        // 成功
        if (status === 'Success') {
          _this.isSearched = true
          _this.$router.push({
            name: 'charts',
            params: {
              type: 0,
              from: 'search',
              data: data,
              name: val
            }
          })
          return
        }
        // 匹配失败
        if (status === 'NotFound') {
          console.log('NotFound')
          Toast({
            message: '暂未找到您查询的小区',
            position: 'middle',
            duration: 2000
          })
          return
        }
        // 模糊匹配
        if (status === 'Guess') {
          _this.isSearched = true
          // 更新数据
          if (type === 0) {
            _this.$store.commit('updateCommunities', data.guess) // 小区
          } else if (type === 1) {
            _this.$store.commit('updateBusinesses', data.guess) // 商圈
          } else if (type === 2) {
            _this.$store.commit('updateCounties', data.guess) // 县区
          }
          return
        }
      })
    }, // 切换路由
    switchRoute: function(argument) {
      // 充值
      if (Tool.query('autopay') !== null && parseInt(Tool.query('autopay')) === 1) {
        this.$router.push('topup')
        return
      }

      // 查询
      var type = Tool.query('type')
      if (type === null) {
        Toast({
          message: '请检查参数',
          position: 'middle',
          duration: 1000
        })
        return
      }

      if (parseInt(type) === 3) {
        // 全北京
        this.$router.push({
          name: 'charts',
          params: {
            type: 1,
            name: '北京'
          }
        })
      } else if (parseInt(type) === 2) {
        // 各县区
        this.$router.push({
          name: 'county',
          params: {}
        })
      } else if (parseInt(type) === 1) {
        // 各商圈
        this.$router.push({
          name: 'business',
          params: {}
        })
      } else if (parseInt(type) === 0) {
        // 您的小区
        this.$router.push({
          name: 'district',
          params: {}
        })
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// NIMain.vue?45126c1e